export default "__VITE_ASSET__qEHO8M4B__"